import type { Category } from "@/lib/skills/types";

const SLUG_TO_CATEGORY: Record<string, Category> = {
  "ui-ux": "UI/UX",
  security: "Security",
  efficiency: "Efficiency",
};

export function categoryFromSlug(slug: string): Category | null {
  return SLUG_TO_CATEGORY[slug.toLowerCase()] ?? null;
}

export const ALL_CATEGORIES: Category[] = ["UI/UX", "Security", "Efficiency"];
